module.exports = __webpack_public_path__ + "img/strategy-main-banner.64e0a981.png";